import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { SavedFilterSource } from './types/saved-filter-source.type';
import type { SavedFilter } from './types/saved-filter.type';

/**
 * Fetches the current user's saved filters for a single source.
 *
 * The user is resolved server-side from the secure cookie / Redis ticket store —
 * no userId is passed.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param source - Page scope (Package Manager / List Manager).
 * @returns OperationResultWithData wrapping `SavedFilter[]`.
 */
export const getSavedFilters = async (instance: KyInstance, source: SavedFilterSource) => {
  try {
    return await instance
      .get<OperationResultWithData<SavedFilter[]>>(Uri.savedFilters.base, {
        searchParams: { source },
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
